import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'dapp';
  isMaintenancePage = false;
  maintenanceEnabled = false;

  constructor(
    private router: Router
  ) {}

  ngOnInit(): void {
    // Verificar si está activado el modo mantenimiento y forzar redirección una sola vez
    this.maintenanceEnabled = !!environment.maintenanceMode;
    if (this.maintenanceEnabled) {
      this.isMaintenancePage = true;
      if (this.router.url !== '/mantenimiento') {
        this.router.navigate(['/mantenimiento'], { replaceUrl: true });
      }
      return; // Evita suscripciones que puedan provocar bucles de navegación
    }

    // Detectar cambios de ruta para ocultar layout principal en mantenimiento
    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd)
      )
      .subscribe((event: NavigationEnd) => {
        const atMaintenance = event.urlAfterRedirects.startsWith('/mantenimiento');
        this.isMaintenancePage = atMaintenance || this.maintenanceEnabled;

        // Mientras mantenimiento esté activo, impedir navegar a cualquier otra ruta
        if (this.maintenanceEnabled && !atMaintenance) {
          this.router.navigate(['/mantenimiento'], { replaceUrl: true });
        }
      });
  }
}